import * as React from 'react';
import * as videoReviews from './videoReviews.module.scss';
import { Modal } from '../../../../../Modal';
import { TaxDeduction } from "../../../../../TaxDeduction";

export const VideoReviews = ({ data, buttonText, widget, showButton }) => {
  const [showModal, setShowModal] = React.useState(false);

  return (
    <section className={videoReviews.videoReviews} id="videoReviews">
      <div className="container">
        {data.map((elem, index) => (
          <div className="row" key={index}>
            <div className={`col-12 col-lg-6 ${videoReviews.videoReviews__col}`}>
              <div className={videoReviews.videoReviews__videoContainer}>
                <div className={videoReviews.videoReviews__videoWrapper}>
                  <iframe
                    className={videoReviews.videoReviews__video}
                    src={elem.source}
                    title={elem.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            </div>

            <div className={`col-12 col-lg-6 ${videoReviews.videoReviews__col}`}>
              <div className={videoReviews.videoReviews__informationWrapper}>
                <div className={videoReviews.videoReviews__quote}>
                  <p className={videoReviews.videoReviews__quoteText}>
                    <i>{elem.quote}</i>
                  </p>
                </div>
                <div>
                  <p className={videoReviews.videoReviews__name}>{elem.name}</p>
                  <p className={videoReviews.videoReviews__description}>{elem.info}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
        {
          showButton ?
            <>
              <button
                className={videoReviews.videoReviews__btn}
                onClick={() => {
                  setShowModal(true);
                }}
              >
                {buttonText}
              </button>
              <TaxDeduction margin={"30px 0 0"} align={"center"}/>
            </>
            : null
        }
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        {widget}
      </Modal>
    </section>
  );
};
